import React, { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { BRAND } from "@/data/brand";

export default function ContactForm({ product = null, onSuccess, compact = false }) {
  const { t } = useLang();
  const f = t.contact.form;
  const [form, setForm] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });

  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error(f.err);
      return;
    }
    const subject = product
      ? `Solicitud de información — ${product.name} (${product.ref || ""})`
      : "Solicitud de información — DPNox";
    const lines = [
      product ? `Producto: ${product.name}${product.ref ? " (" + product.ref + ")" : ""}` : null,
      `Nombre: ${form.name}`,
      form.company ? `Empresa: ${form.company}` : null,
      `Email: ${form.email}`,
      form.phone ? `Teléfono: ${form.phone}` : null,
      "",
      form.message,
    ].filter((l) => l !== null);
    const body = lines.join("\n");
    const mailto = `mailto:${BRAND.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
    toast.success(f.ok);
    setForm({ name: "", company: "", email: "", phone: "", message: "" });
    onSuccess && onSuccess();
  };

  const inputCls =
    "w-full bg-white/5 border border-white/12 px-4 py-3 text-white placeholder:text-white/35 focus:outline-none focus:border-[color:var(--dp-orange)] transition-colors text-sm";

  return (
    <form onSubmit={submit} data-testid="contact-form" className="space-y-3">
      {product && (
        <div className="mb-1 border border-[color:var(--dp-orange)]/40 bg-[color:var(--dp-orange)]/10 px-4 py-3">
          <span className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--dp-orange)]">
            {f.product}
          </span>
          <p className="text-white text-sm font-medium mt-0.5" data-testid="contact-product-name">
            {product.name}
          </p>
        </div>
      )}
      <div className={compact ? "" : "grid grid-cols-1 sm:grid-cols-2 gap-3"}>
        <input
          data-testid="contact-name"
          className={inputCls}
          placeholder={f.name}
          value={form.name}
          onChange={set("name")}
        />
        {!compact && (
          <input
            data-testid="contact-company"
            className={inputCls}
            placeholder={f.company}
            value={form.company}
            onChange={set("company")}
          />
        )}
      </div>
      <div className={compact ? "space-y-3" : "grid grid-cols-1 sm:grid-cols-2 gap-3"}>
        <input
          data-testid="contact-email"
          type="email"
          className={inputCls}
          placeholder={f.email}
          value={form.email}
          onChange={set("email")}
        />
        <input
          data-testid="contact-phone"
          className={inputCls}
          placeholder={f.phone}
          value={form.phone}
          onChange={set("phone")}
        />
      </div>
      <textarea
        data-testid="contact-message"
        rows={compact ? 3 : 4}
        className={inputCls + " resize-none"}
        placeholder={f.placeholder}
        value={form.message}
        onChange={set("message")}
      />
      <button
        type="submit"
        data-testid="contact-submit"
        className="inline-flex w-full items-center justify-center gap-2 bg-[color:var(--dp-orange)] hover:bg-[color:var(--dp-orange-hover)] text-black font-semibold py-3.5 transition-colors"
      >
        <Send size={17} /> {f.send}
      </button>
    </form>
  );
}
